import { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Grid,
} from "@mui/material";

const YesNo = ({ question, onChange }) => {
  // Local state to manage the selected value
  const [value, setValue] = useState(question.answer || "");

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue); // Update local state
    onChange(question._id, newValue); // Notify parent component
  };

  return (
    <Grid item xs={12}>
      <FormControl fullWidth>
        <InputLabel>{question.question}{question.required ? " *" : ""}</InputLabel>
        <Select
          value={value}
          onChange={handleChange}
          label={question.question}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
        {question.description && (
          <Typography variant="caption" color="textSecondary" mt={1}>
            {question.description}
          </Typography>
        )}
      </FormControl>
    </Grid>
  );
};

export default YesNo;
